





















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { collections, firestore } from "@/configs/firebase";
import { objectify } from "@/helpers";
import logger from "@/configs/logger";
import { throttle } from "lodash";

@Component
export default class LeadPaymentDetails extends Vue {
  @Prop({ required: true }) lead!: any;

  paymentDetails: any = {};
  autoUpdate!: Function;

  @Watch("paymentDetails")
  onPaymentChange(val: any) {
    if (Object.keys(val).length) {
      this.autoUpdate(false, val);
    }
  }

  created() {
    this.autoUpdate = throttle(this.savePaymentDetails, 200, { leading: true });
  }

  get disabled() {
    return !Object.keys(this.paymentDetails).length;
  }

  async updatePaymentDetails(val: string, key: string) {
    this.paymentDetails = { ...this.paymentDetails, [key]: val };
    this.$nextTick(function() {
      if (key === "credit_card_number") {
        if (val.length >= 19) return;
        const masked = val.replace(/[^0-9]/g, "").replace(/(.{4})/g, "$1-");
        this.paymentDetails = {
          ...this.paymentDetails,
          [key]: masked
        };
      }
    });
  }

  async savePaymentDetails(
    notify = true,
    paymentDetails = this.paymentDetails
  ) {
    try {
      const details = {
        ...objectify(this.lead.payment_details),
        ...paymentDetails
      };
      await collections.lead
        .doc(this.lead.id)
        .update({ payment_details: details });
      notify && this.$toasted.success("Payment details saved.").goAway(2000);
      logger("info", this.paymentDetails);
    } catch (err) {
      logger("error", "payment details save error", err);
      this.$toasted.error("Payment details failed to save.");
    }
  }
}
